import { createSlice } from "@reduxjs/toolkit";

export const dataInfoSlice = createSlice(
    {
        name: 'base api',
        initialState: {
            urlApi: '',
            date: ''
        },
        reducers: {
            setUrlApi: (state, action) => {
                state.urlApi = action.payload
            },
            setDate: (state, action) => {
                state.date = action.payload
            }
        }

    }
)
export const dataInfoReducer = dataInfoSlice.reducer
export const dataInfoAction = dataInfoSlice.actions
export const dataInfo = (state) => state.dataInfoReducer
export default dataInfoReducer

